<div class="container">
    <div class="error">
        <app-error-alert [message]="errorMessage" *ngIf="showAlertError"></app-error-alert>
    </div>
    <section class="unlock-users">
        <form class="form-wrapper" #consultPhonesForm="ngForm" (ngSubmit)="onSubmit(consultPhonesForm)">
            <div class="form-inner">
                <div class="form-section">
                    <div class="form-group">
                        <label for="phone-input" class="form-label">Telefonos</label>
                        <textarea id="phone-input" class="form-input form-textarea" type="text"
                            placeholder="Ingresa Telefonos Separados Por ," [(ngModel)]="phonesInput" name="phoneInput"
                            #phonesModel="ngModel" required>
                        </textarea>
                        <div *ngIf="phonesModel.invalid && phonesModel.touched" class="error-message">
                            <i class="error-icon">&#9888;</i>
                            <span class="error-text">Este campo es requerido!</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button type="button" class="btn btn-cancel" (click)="cancel(consultPhonesForm)"
                    [ngClass]="{'btn-cancel-valid': consultPhonesForm.valid}">Cancelar</button>
                <button type="submit" class="btn btn-unlock" [ngClass]="{'btn-valid': consultPhonesForm.valid}"
                    [disabled]="consultPhonesForm.invalid">Consultar</button>
            </div>
        </form>
    </section>
</div>

<!-- <section class="results-container" *ngIf="paginatedPhones.length > 0">
    <div class="results-surface">
        <div class="results-content">
            <header class="results-header">
                <h2 class="results-title">Resultados</h2>
                <div class="results-divider">
                    <hr class="results-line">
                </div>
            </header>
            <div class="results-body">
                <div class="results-table">

                    <div class="results-columns-wrapper">
                        <div class="results-column">
                            <div class="results-cell-header"></div>
                            <div class="results-cell" *ngFor=" let crcPhone of crcPhones; let i= index">{{i+1}}</div>
                            <div class="results-cell-empty"></div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Celular</div>
                            <div class="results-cell" *ngFor=" let crcPhone of crcPhones">{{crcPhone.llave}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Aplicacion</div>
                            <div class="results-cell" *ngFor="let crcPhone of crcPhones">
                                {{crcPhone.opcionesContacto.aplicacion}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Llamada</div>
                            <div class="results-cell" *ngFor="let crcPhone of crcPhones">
                                {{crcPhone.opcionesContacto.llamada}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Sms</div>
                            <div class="results-cell" *ngFor="let crcPhone of crcPhones">
                                {{crcPhone.opcionesContacto.sms}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-controls">
                    <button (click)="previousPage()" [disabled]="pageIndex === 0">Anterior</button>
                    <button (click)="nextPage()" [disabled]="!hasNextPage()">Siguiente</button>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="results-container" *ngIf="paginatedPhones.length > 0">
    <div class="results-surface">
        <div class="results-content">
            <header class="results-header">
                <h2 class="results-title">Resultados</h2>
                <div class="results-divider">
                    <hr class="results-line">
                </div>
            </header>
            <div class="results-body">
                <div class="results-table">

                    <div class="results-columns-wrapper">
                        <div class="results-column">
                            <div class="results-cell-header"></div>
                            <div class="results-cell" *ngFor="let crcPhone of paginatedPhones; let i = index">
                                <b>{{(pageIndex * pageSize) + i + 1}}</b>
                            </div>
                            <div class="results-cell-empty"></div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Celular</div>
                            <div class="results-cell" *ngFor="let crcPhone of paginatedPhones">{{crcPhone.llave}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Aplicacion</div>
                            <div class="results-cell" *ngFor="let crcPhone of paginatedPhones">
                                {{crcPhone.opcionesContacto.aplicacion}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Llamada</div>
                            <div class="results-cell" *ngFor="let crcPhone of paginatedPhones">
                                {{crcPhone.opcionesContacto.llamada}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Sms</div>
                            <div class="results-cell" *ngFor="let crcPhone of paginatedPhones">
                                {{crcPhone.opcionesContacto.sms}}
                            </div>
                        </div>
                    </div>
                </div>
                <app-paginator [totalItems]="crcPhones.length" [initialPageSize]="pageSize"
                    (pageChange)="onPageChange($event)">
                </app-paginator>
            </div>
        </div>
    </div>
</section>